import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiPath from '../../utils/apiPath';

/* fetch all roles */
export const fetchRoles = createAsyncThunk(
  "roles",
  async ( {clientId, page, limit, search, field},{rejectWithValue} ) => {
    try { 
    const response = await apiPath.get(`/api/v1.0/roles?page=${page}&limit=${limit}${clientId?`&client_id=${clientId}`:""}${search?`&value=${search}`:""}${field?`&field=${field}`:""}${search && field?`&operator=equals`:""}`);     
    return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/* create role */
export const createRole = createAsyncThunk(
  "role/create",
  async (roleData,{ rejectWithValue }) => {
    try {
      const response = await apiPath.post('/api/v1.0/roles/create', roleData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/* update role */
export const updateRole = createAsyncThunk(
  "role/update",
  async ({ id, roleData },{ rejectWithValue }) => {
    try {
      const response = await apiPath.put(`/api/v1.0/roles/${id}`, roleData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/* role detail */
export const roleDetail = createAsyncThunk(
  "role/detail",
  async ( id ,{ rejectWithValue }) => {
    try {
      const response = await apiPath.get(`/api/v1.0/roles/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/* delete role */
export const deleteRole = createAsyncThunk(
  "role/delete",
  async ( id ,{ rejectWithValue }) => {
    try {
      await apiPath.delete(`/api/v1.0/roles/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/* fetch role lists */
export const roleLists = createAsyncThunk(
  "role/list",
  async ({clientId}, rejectWithValue ) => {
    try {
      const response = await apiPath.get(`/api/v1.0/roles/lists${clientId?`?client_id=${clientId}`:''}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/* Role Slice @start */
const roleSlice = createSlice({
  name: 'role',
  initialState: {
    roles: [],
    loading: false,
    error: null,
    allRoleLists:[],
    totalRecord:0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* Fetch Roles */
      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.roles = action.payload.roles;
         state.totalRecord = action.payload.totalRecord
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Create Role */
      .addCase(createRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.roles.push(action.payload);
         state.totalRecord = state.totalRecord+1
      })
      .addCase(createRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Update Role */
        .addCase(updateRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const index = state.roles.findIndex(
          (role) => role.id === action.payload.id
        );
        if (index !== -1) {
          state.roles[index] = action.payload;
        }
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Delete Role */
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.roles = state.roles.filter(
          (role) => role.id !== action.payload
        );
         state.totalRecord = state.totalRecord-1
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      /* Role Details */
      .addCase(roleDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(roleDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.roleDetail = action.payload.details;
      })
      .addCase(roleDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
    
      /* Role Lists */
      .addCase(roleLists.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(roleLists.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.roles = action.payload;
        state.allRoleLists = action.payload.roles
      })
      .addCase(roleLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default roleSlice.reducer;
